import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../../shared/api/api.tokens';
import { API_ENDPOINTS } from '../../shared/common/apiConstants';
import { Observable } from 'rxjs';
import { PublicEvent } from '../../shared/interfaces';

@Injectable({ providedIn: 'root' })
export class PublicEventsService {
  private http = inject(HttpClient);
  private baseUrl = inject(API_BASE_URL);

  getEvent(eventId: string): Observable<PublicEvent> {
    return this.http.get<PublicEvent>(
      `${this.baseUrl}${API_ENDPOINTS.public.events}/${eventId}`
    );
  }

  confirmEvent(eventId: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.baseUrl}${API_ENDPOINTS.public.events}/${eventId}/confirm`,
      {}
    );
  }

  cancelEvent(eventId: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.baseUrl}${API_ENDPOINTS.public.events}/${eventId}/cancel`,
      {}
    );
  }
}
